/* eslint-disable import/no-unresolved */
/* @ts-nocheck */
/* @ts-ignore */

import React, { Suspense } from "react";
import injectModules from "containers/module-federation/module-injector";
import { Spinner } from "@nuorder/components";
import { loadRemote } from "@module-federation/enhanced/runtime";

const AsyncEventTrackerWrapper = React.lazy(async () => {
    return await loadRemote("Payments/AsyncEventTracker");
});

const AsyncEventTrackerWrapperContainer = (props) => {
    return <Suspense fallback={<Spinner />}>{injectModules(AsyncEventTrackerWrapper, props)}</Suspense>;
};

export default AsyncEventTrackerWrapperContainer;
